import { useEffect, useRef, useState } from "react";
import Button from "../../Button";
import T from "../../../i18n/Text";
import { useTranslation } from 'react-i18next';

interface Props {
    playerName: string;
    onNameSet: (name: string) => void;
}
const AddName = ({ playerName, onNameSet}: Props) => {
    const [name, setName] = useState(playerName || "");
    const { t } = useTranslation();
    const inputEl = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (inputEl.current) {
            inputEl.current.focus();
        }
     }, []);

    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value);

    const onNextClick = () => {
        onNameSet(name);
    }


    const title = playerName ? <T path='games.titles.editName' /> : <T path='games.titles.addName' />;

    return (
        <>
            <h3 className="text-[20px] font-medium leading-6 m-0">{title}</h3>
            <input type="text" onChange={handleNameChange} ref={inputEl}
                placeholder={(t('games.placeholders.name', { defaultValue: '' }) as string)}
                defaultValue={playerName}
                className="text-center mt-[69px] mb-[80px] border-b-[1px] border-black w-[210px] outline-none text-[20px] leading-6"/>
            <Button disabled={!name} type="primary" onClick={onNextClick} name="add-name-next"><T path='games.buttons.next'/></Button>
        </>
    )
}

export default AddName;
